import React from 'react'
import PropTypes from 'prop-types'
import Tooltip from '@material-ui/core/Tooltip'
import { withStyles } from '@material-ui/core/styles'

import FieldErrorIcon from '../../../../assets/images/icons/ico_field_error.svg'

class InputValidationTooltip extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    title: PropTypes.node.isRequired,
  }

  static styles = (theme) => ({
    tooltip: {
      fontSize: '14px',
      fontWeight: 'normal',
      backgroundColor: '#fff',
      backgroundImage: `url(${FieldErrorIcon})`,
      backgroundPosition: '8px 8px',
      backgroundRepeat: 'no-repeat',
      color: 'rgba(0, 0, 0, 0.87)',
      padding: theme.spacing(1, 1, 1, 4),
      border: '1px solid #c4c4c4',
      marginTop: '10px',
      position: 'relative',
      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
      borderRadius: '3px',
      '& .validation-tooltip-arrow::before, & .validation-tooltip-arrow::after': {
        content: `${"''"}`,
        display: 'block',
        position: 'absolute',
        marginTop: '-5px',
        width: 0,
        height: 0,
        borderStyle: 'solid',
        top: 0,
        left: '20px',
        borderColor: 'transparent transparent #fff transparent',
        borderWidth: '0 4px 7px 4px',
      },
      '& .validation-tooltip-arrow::before': {
        top: '-2px',
        borderColor: 'transparent transparent #c4c4c4 transparent',
        borderWidth: '0 4px 7px 4px',
      },
    },
  })

  render() {
    const { classes } = this.props

    return (
      <Tooltip
        open
        placement="bottom-start"
        classes={{ tooltip: classes.tooltip }}
        title={(
          <>
            <div className="validation-tooltip-arrow" />
            { this.props.title }
          </>
        )}
      >
        <div />
      </Tooltip>
    )
  }
}

export default withStyles(InputValidationTooltip.styles)(InputValidationTooltip)
